import React from 'react'
import styles from './FormBody.module.scss'
import { classNames } from '@/components/shared/classNames'

export interface FormBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}

const FormBody = ({ className, children }: FormBodyProps) => {
  return <div className={classNames(className, styles['form-body'])}>{children}</div>
}

export default FormBody
